import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1016.471,0 L1016.471,564.706 L1581.176,564.706 L1581.176,1920 L0,1920 L0,0 L1016.471,0 Z M790.701,1355.294 L338.823,1355.294 L338.823,1468.348 L790.701,1468.348 L790.701,1355.294 Z M1129.412,1129.413 L338.823,1129.413 L338.823,1242.353 L1129.412,1242.353 L1129.412,1129.413 Z M1016.471,903.529 L338.823,903.529 L338.823,1016.47 L1016.471,1016.47 L1016.471,903.529 Z M1242.353,677.647 L338.823,677.647 L338.823,790.588 L1242.353,790.588 L1242.353,677.647 Z M790.701,451.878 L338.823,451.878 L338.823,564.819 L790.701,564.819 L790.701,451.878 Z",
  transform: "translate(169)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1498.6729,345.623 C1529.0539,375.891 1550.5129,412.258 1564.2919,451.787 L1129.3549,451.787 L1129.3549,16.851 C1168.8849,30.63 1205.2519,52.201 1235.6329,82.47 L1498.6729,345.623 Z",
  transform: "translate(169)"
}));

var IconDocumentSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDocumentSolid, _Component);

  var _super = _createSuper(IconDocumentSolid);

  function IconDocumentSolid() {
    _classCallCheck(this, IconDocumentSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDocumentSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDocument",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconDocumentSolid.displayName = "IconDocumentSolid";
  return IconDocumentSolid;
}(Component);

IconDocumentSolid.glyphName = 'document';
IconDocumentSolid.variant = 'Solid';
IconDocumentSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDocumentSolid;
export { IconDocumentSolid };